import { Injectable, signal, computed } from '@angular/core';
import { STORAGE_KEYS } from '../../constants/app.constants';
import { User } from '../../models/auth.model';

@Injectable({ providedIn: 'root' })
export class TokenService {
  private readonly accessToken = signal<string | null>(
    this.getStored(STORAGE_KEYS.ACCESS_TOKEN)
  );
  private readonly currentUser = signal<User | null>(this.getStoredUser());

  readonly isAuthenticated = computed(() => !!this.accessToken());
  readonly user = computed(() => this.currentUser());

  getAccessToken(): string | null {
    return this.accessToken();
  }

  setToken(token: string): void {
    this.accessToken.set(token);
    localStorage.setItem(STORAGE_KEYS.ACCESS_TOKEN, token);
  }

  setUser(user: User): void {
    this.currentUser.set(user);
    localStorage.setItem(STORAGE_KEYS.USER, JSON.stringify(user));
  }

  clearAll(): void {
    this.accessToken.set(null);
    this.currentUser.set(null);
    localStorage.removeItem(STORAGE_KEYS.ACCESS_TOKEN);
    localStorage.removeItem(STORAGE_KEYS.USER);
  }

  private getStored(key: string): string | null {
    return localStorage.getItem(key);
  }

  private getStoredUser(): User | null {
    const raw = localStorage.getItem(STORAGE_KEYS.USER);
    if (!raw) return null;
    try {
      return JSON.parse(raw) as User;
    } catch {
      return null;
    }
  }
}
